"use client";

import { useEffect } from "react";
import { initDeferredAnalytics } from "@/lib/deferredThirdParty";

export function AnalyticsBootstrap() {
  useEffect(() => {
    initDeferredAnalytics();
  }, []);

  return null;
}
